import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const EyeIcon = ({ size = 24, className = "" }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const CogsIcon = ({ size = 24, className = "" }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2v4" />
    <path d="M12 18v4" />
    <path d="M4.93 4.93l2.83 2.83" />
    <path d="M16.24 16.24l2.83 2.83" />
    <path d="M2 12h4" />
    <path d="M18 12h4" />
    <path d="M4.93 19.07l2.83-2.83" />
    <path d="M16.24 7.76l2.83-2.83" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const UserIcon = ({ size = 24, className = "" }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const BellIcon = ({ size = 24, className = "" }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8a6 6 0 0 0-6-6v-1a1 1 0 0 0-2 0v1a6 6 0 0 0-6 6v3c0 2.22 1.21 4.3 3.42 5.37L10 21h4c2.21-1.07 3.42-3.15 3.42-5.37V8z" />
    <path d="M9 21v-1a3 3 0 0 1 6 0v1" />
  </svg>
);
const SignOutIcon = ({ size = 24, className = "" }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
    <polyline points="10 17 15 12 10 7" />
    <line x1="15" x2="3" y1="12" y2="12" />
  </svg>
);

const Sidebar = ({ user, onSignOut }) => {
  const location = useLocation();
  
  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <div className="w-64 bg-gray-800 p-6 flex flex-col justify-between border-r border-gray-700">
      <div>
        <h1 className="text-2xl font-bold mb-8 text-white flex items-center">
          <EyeIcon className="mr-3 text-blue-400" /> BlackBox
        </h1>
        <nav className="space-y-4">
          <Link 
            to="/" 
            className={`flex items-center w-full px-4 py-3 rounded-lg text-left transition-colors duration-200 ${
              isActive('/') ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'
            }`}
          >
            <CogsIcon className="mr-3" />
            Dashboard
          </Link>
          <Link 
            to="/alerts" 
            className={`flex items-center w-full px-4 py-3 rounded-lg text-left transition-colors duration-200 ${
              isActive('/alerts') ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'
            }`}
          >
            <BellIcon className="mr-3" />
            Alerts
          </Link>
          <Link 
            to="/account" 
            className={`flex items-center w-full px-4 py-3 rounded-lg text-left transition-colors duration-200 ${
              isActive('/account') ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'
            }`}
          >
            <UserIcon className="mr-3" />
            Account
          </Link>
        </nav>
      </div>
      <div className="mt-8">
        <span className="block text-sm text-gray-500 mb-2 truncate" title={user.email}>
          Logged in as: {user.email}
        </span>
        <button onClick={onSignOut} className="flex items-center w-full px-4 py-3 text-red-400 hover:bg-red-900 hover:bg-opacity-20 rounded-lg transition-colors duration-200">
          <SignOutIcon className="mr-3" />
          Log Out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;